export default {
    props: {
        pdfAllPages: {
            type: Boolean,
            kComposite: 'pdf.allPages'
        }, 
        pdfAuthor: {
            type: String,
            kComposite: 'pdf.author'
        }, 
        pdfAvoidLinks: {
            type: Boolean | String,
            kComposite: 'pdf.avoidLinks'
        }, 
        pdfCreator: {
            type: String,
            kComposite: 'pdf.creator'
        }, 
        pdfDate: {
            type: Date,
            kComposite: 'pdf.date'
        }, 
        pdfFileName: {
            type: String,
            kComposite: 'pdf.fileName'
        }, 
        pdfForceProxy: {
            type: Boolean,
            kComposite: 'pdf.forceProxy'
        }, 
        pdfKeywords: {
            type: String,
            kComposite: 'pdf.keywords'
        }, 
        pdfLandscape: {
            type: Boolean,
            kComposite: 'pdf.landscape'
        }, 
        pdfMarginBottom: {
            type: Number | String,
            kComposite: 'pdf.margin.bottom'
        }, 
        pdfMarginLeft: {
            type: Number | String,
            kComposite: 'pdf.margin.left'
        }, 
        pdfMarginRight: {
            type: Number | String,
            kComposite: 'pdf.margin.right'
        }, 
        pdfMarginTop: {
            type: Number | String,
            kComposite: 'pdf.margin.top'
        }, 
        pdfPaperSize: {
            type: String | Array,
            kComposite: 'pdf.paperSize'
        }, 
        pdfTemplate: {
            type: String,
            kComposite: 'pdf.template'
        }, 
        pdfRepeatHeaders: {
            type: Boolean,
            kComposite: 'pdf.repeatHeaders'
        }, 
        pdfScale: {
            type: Number,
            kComposite: 'pdf.scale'
        }, 
        pdfProxyURL: {
            type: String,
            kComposite: 'pdf.proxyURL'
        }, 
        pdfProxyTarget: {
            type: String,
            kComposite: 'pdf.proxyTarget'
        }, 
        pdfSubject: {
            type: String,
            kComposite: 'pdf.subject'
        }, 
        pdfTitle: {
            type: String,
            kComposite: 'pdf.title'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Pdf.js